/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Drawer from '@mui/material/Drawer'
import { styled } from '@mui/material/styles'

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme
  const { transparentSidenav, miniSidenav } = ownerState

  const sidebarWidth = 300
  const { white, transparent, parco } = palette
  const { xxl } = boxShadows
  const { pxToRem } = functions

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    backgroundColor: white.main,
    boxShadow: '0px 4px 25px -8px #00000033',
    width: sidebarWidth,
    overflow: 'visible',
    transform: 'translateX(0)',
    transition: transitions.create(['width', 'transform'], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    '& #toggleMiniSideNavFloatingButton': {
      right: -50,
      position: 'absolute',
      zIndex: 1000,
      transition: transitions.create(['right'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },

    [breakpoints.up('lg')]: {
      backgroundColor: transparentSidenav ? white.main : white.main,
      boxShadow: '0px 4px 25px -8px #00000033',
      marginBottom: transparentSidenav ? 0 : 'inherit',
      left: '0',
      width: sidebarWidth,
      transform: 'translateX(0)',
      transition: transitions.create(['width', 'background-color'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
      '& #toggleMiniSideNavFloatingButton': {
        display: 'none',
      },
    },
  })

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    backgroundColor: white.main,
    overflow: 'visible',
    transform: `translateX(${pxToRem(-270)})`,
    transition: transitions.create(['width', 'transform'], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
    '& #toggleMiniSideNavFloatingButton': {
      right: -70,
      position: 'absolute',
      zIndex: 1000,
      transition: transitions.create(['right'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },

    [breakpoints.up('lg')]: {
      backgroundColor: white.main,
      boxShadow: '0px 4px 25px -8px #00000033',
      marginBottom: transparentSidenav ? 0 : 'inherit',
      left: '0',
      width: sidebarWidth,
      transform: 'translateX(0)',
      transition: transitions.create(['width', 'background-color'], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
      '& #toggleMiniSideNavFloatingButton': {
        display: 'none',
      },
    },
  })

  return {
    '& .MuiDrawer-paper': {
      boxShadow: xxl,
      border: 'none',

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  }
})
